module.exports = __webpack_public_path__ + "static/media/sam.0787cc70.png";